export default __webpack_public_path__ + "static/media/list.f98b98b4.svg";